import React from "react";
import { Link } from "react-router-dom";
const Campuscare = () => {
  return (
    <>
      <div className="campuslogo">
        <Link to="https://ghssidhi.campussoft.net/" target="_blank">
          <img
            src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/GHSS/public/Images/Campulogo.png"
            className="img-fluid float-end campus"
            alt="Gandhi High School, Sidhi - Madhya Pradesh"
          />
        </Link>
      </div>
    </>
  );
};

export default Campuscare;
